import CryptoJS from 'crypto-js';

// Secret key and IV (same as in PHP)
const secretKey = 'Maddy33225@$#Mihir1901@$#Mihir191192@$#)(*&^%!'; // 256-bit key
const secretIv = 'bgsdhzfgjhfvhasdvfjkvbsdfgsd5fg4df56g45sdfa4ewr5t53454354356454*^&^&%%^#%$#@%'; 

// Hash the secret key and IV
const key = CryptoJS.SHA256(secretKey).toString(CryptoJS.enc.Hex).substring(0, 32); // Ensure it's 32 bytes (256-bit)
const iv = CryptoJS.SHA256(secretIv).toString(CryptoJS.enc.Hex).substring(0, 16); // Ensure it's 16 bytes for IV

/**
 * Encrypts or decrypts a string using AES-256-CBC.
 * @param {string} string - The string to encrypt or decrypt.
 * @param {string} action - 'e' for encrypt, 'd' for decrypt.
 * @returns {string} - The encrypted or decrypted string.
 */
const mySimpleCrypt = (string, action) => {
  let output = '';

  if (action === 'e') {
    // Encrypt
    const encrypted = CryptoJS.AES.encrypt(string, CryptoJS.enc.Hex.parse(key), {
      iv: CryptoJS.enc.Hex.parse(iv),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    output = encrypted.toString(); // The encrypted string
  } else if (action === 'd') {
    // Decrypt
    const decrypted = CryptoJS.AES.decrypt(string, CryptoJS.enc.Hex.parse(key), {
      iv: CryptoJS.enc.Hex.parse(iv),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    console.log(decrypted);
    output = decrypted.toString(CryptoJS.enc.Utf8); // Return as UTF-8 string
    console.log(output);
  }

  return output;
};

export default mySimpleCrypt;



// import { useState, useEffect } from 'react';

// // Utility to convert to and from base64
// const fromBase64 = (base64) => {
//   // Check if the input is a valid non-empty base64 string
//   if (!base64 || typeof base64 !== 'string') {
//     throw new Error('Input is not a valid base64 string');
//   }

//   // Ensure the base64 string is sanitized (e.g., no extra spaces, line breaks, etc.)
//   const sanitizedBase64 = base64.replace(/[^A-Za-z0-9+/=]/g, '');

//   // Decode the sanitized base64 string into a Uint8Array
//   try {
//     return new Uint8Array(atob(sanitizedBase64).split('').map(char => char.charCodeAt(0)));
//   } catch (error) {
//     console.error('Invalid base64 string:', error);
//     throw new Error('Failed to decode base64 string');
//   }
// };

// // Utility to hash a string with SHA-256
// const hashSHA256 = async (str) => {
//   const encoder = new TextEncoder();
//   const data = encoder.encode(str);
//   const hashBuffer = await crypto.subtle.digest('SHA-256', data);
//   return new Uint8Array(hashBuffer);
// };

// // Decryption utility function (AES-256-CBC)
// async function mySimpleCrypt(data) {
//   const secretKey = 'Maddy33225@$#Mihir1901@$#Mihir191192@$#)(*&^%!'; // Secret key
//   const secretIv = 'bgsdhzfgjhfvhasdvfjkvbsdfgsd5fg4df56g45sdfa4ewr5t53454354356454*^&^&%%^#%$#@%'; // Secret IV
  
//   const key = await hashSHA256(secretKey); // Hash the key using SHA-256
//   const iv = new Uint8Array(await hashSHA256(secretIv)); // Hash the IV and slice to 16 bytes

//   const encryptMethod = 'AES-CBC'; // Encryption method (AES-256-CBC)

//   // Decrypting
//   try {
//     const decodedData = fromBase64(data); // Decode base64 ciphertext
//     const decryptedData = await crypto.subtle.decrypt(
//       {
//         name: encryptMethod,
//         iv: iv.slice(0, 16), // AES-256-CBC needs a 16-byte IV
//       },
//       key,
//       decodedData,
//     );
//     const decodedString = new TextDecoder().decode(decryptedData); // Convert decrypted data to string
//     return decodedString;
//   } catch (error) {
//     console.error('Decryption failed:', error);
//     return null; // Return null in case of error
//   }
// }

// // Custom hook for decrypting and managing state
// const useDecryptedValue = (encryptedData) => {
//   const [decryptedValue, setDecryptedValue] = useState('');
//    console.log(encryptedData);
//   useEffect(() => {
//     const decryptValue = async () => {
//       try {
//         const decrypted = await mySimpleCrypt(encryptedData);
//         setDecryptedValue(decrypted);
//       } catch (error) {
//         setDecryptedValue(null);
//       }
//     };

//     decryptValue();
//   }, [encryptedData]);

//   return decryptedValue;
// };

// export default useDecryptedValue;
